import { PageProps, graphql, navigate } from "gatsby";
import {
  SimplifyGatsbyQuery,
  Locale,
  DigitalRideMediaQrCodeConnectBlock,
  DigitalRideMediaService,
  parseAlbumId,
  StaticConfigContextType,
} from "@parksandresorts/core";
import { LocaleToPathConfig } from "../create-page/create-ride-media-pages";
import { RideMediaCommon } from "./digital-ride-media-common";

export type RideMediaQrCodePageData = SimplifyGatsbyQuery<Queries.RideMediaQrCodePageQuery> & {
  contentfulEcommerceConfig: SimplifyGatsbyQuery<Queries.ECommerceConfigFragment> & {
    shopServicePreferredPaymentProvider: StaticConfigContextType["eCommerce"]["preferredPaymentProvider"];
  };
};
export type RideMediaQrCodePageContext = {
  siteConfigId: string;
  /* We get this through the page context since it didn't work to import it from the other file*/
  localesToPath: LocaleToPathConfig;
};

export { Head } from "components/head/ride-media-qr-code-page-head";

export default function RideMediaQrCodePage(props: PageProps<RideMediaQrCodePageData, RideMediaQrCodePageContext>) {
  const {
    contentfulSiteConfiguration: siteConfig,
    allLocalSearchSvPage,
    allLocalSearchEnPage,
    contentfulEcommerceConfig,
  } = props.data;

  const currentLocale = siteConfig.node_locale as unknown as Locale;

  // The QR code value _is_ an album ID. At least at time of writing.
  const qrCode = parseAlbumId(props.params["*"]);
  const slugsWithPotentialQrCodes = {
    sv: qrCode ? `${props.pageContext.localesToPath.qrCode.sv}/${qrCode}` : props.pageContext.localesToPath.qrCode.sv,
    en: qrCode ? `${props.pageContext.localesToPath.qrCode.en}/${qrCode}` : props.pageContext.localesToPath.qrCode.en,
  };

  return (
    <RideMediaCommon
      siteConfig={siteConfig}
      allLocalSearchSvpage={allLocalSearchSvPage}
      allLocalSearchEnpage={allLocalSearchEnPage}
      contentfulEcommerceConfig={contentfulEcommerceConfig}
      currentContentPageSlugs={slugsWithPotentialQrCodes}
    >
      {qrCode && (
        <DigitalRideMediaQrCodeConnectBlock
          service={DigitalRideMediaService}
          navigateToAlbum={(albumId) => {
            window.scrollTo({ top: -100, behavior: "smooth" });
            navigate(`${props.pageContext.localesToPath.album[currentLocale]}/${albumId}`);
          }}
          qrCodeAccountId={qrCode}
        />
      )}
    </RideMediaCommon>
  );
}

export const pageQuery = graphql`
  query RideMediaQrCodePage($siteConfigId: String!, $node_locale: String!) {
    contentfulSiteConfiguration(id: { eq: $siteConfigId }) {
      ...SiteConfiguration
    }
    allLocalSearchSvPage {
      ...LunrSearchNodesSv
    }
    allLocalSearchEnPage {
      ...LunrSearchNodesEn
    }
    contentfulEcommerceConfig(node_locale: { eq: $node_locale }, primary: { eq: true }) {
      ...ECommerceConfig
    }
  }
`;
